import { Component,Inject,OnInit,PLATFORM_ID,Renderer2,RendererFactory2,TemplateRef,ViewChild} from '@angular/core';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { FormGroup } from '@angular/forms';
import { FormBuilder,Validators } from '@angular/forms';
import { MainserviceService } from 'src/app/mainservice.service';
import Swal from 'sweetalert2';
import { DatePipe, isPlatformBrowser } from '@angular/common';
import { MatDatepicker } from '@angular/material/datepicker';
import { Title, Meta } from '@angular/platform-browser';
import { Router } from '@angular/router';
import * as ngxSeo from 'ngx-seo';
@Component({
  selector: 'app-medeilstandalone',
  templateUrl: './medeilstandalone.component.html',
  styleUrls: ['./medeilstandalone.component.scss'],
  providers:[MainserviceService,DatePipe]
})
export class MedeilstandaloneComponent {
  enquiryForm:FormGroup;
  totalcountry:any=[];
  captcha:any
  errorcaptcha:any
  ecaptcha:boolean=false;
  dialcode:any;
  showElement: boolean = false;
  showElementsave: boolean = false;
  @ViewChild('picker') picker!: MatDatepicker<Date>;
  @ViewChild('inputField') inputField!: any;
  currentTime: Date;
  timeSlots:any=[];
  timezone:any;
  appointment_time:boolean=false;
  selectedTime: string | null = null;
  leads:any;
  private renderer: Renderer2;
constructor(private ngxsmartservice:NgxSmartModalService,private fb:FormBuilder,private router:Router,private seoService: ngxSeo.SeoSocialShareService,
  private mainservice:MainserviceService,private datePipe: DatePipe,private title:Title,private meta:Meta,private jsonLdService: ngxSeo.JsonLdService,rendererFactory: RendererFactory2,@Inject(PLATFORM_ID) private platformId: Object){
    this.setSeoMeta();
    if (isPlatformBrowser(this.platformId)) {
    this.renderer = rendererFactory.createRenderer(null, null);
    this.setSchemaData();

    this.setFaqSchemaData();
    this.setWebsiteSchema();
    // this.title.setTitle("Transform Your Pharmacy with Medeil Software | Free Download");

    // Add meta tags dynamically
    // this.meta.addTag({ name: 'description', content: 'Discover how Medeil can revolutionize your pharmacy operations. Download now! Start freely access our best pharmacy software' });
    // this.meta.addTag({ name: 'keywords', content: 'Medeil, Pharmacy Management System, Pharmacy Billing Software, Medical Shop Software, Pharmacy Inventory Software' });
  this.timezone=sessionStorage.getItem('timezone');
  this.enquiryForm=this.fb.group({
      leadname: ['',[ Validators.required]],
      organizationname: ['',[Validators.required]],
      leadsourceid: ['',[]],
      leadsource: ['medeil website',[]],
      sourceRef1: ['',[]],
      sourceRef2: ['',[]],
      description: ['',[ Validators.required]],
      primaryphone: ['',[Validators.required]],
      primaryemail: ['',[Validators.required, Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$')]],
      address1: ['',[]],
      address2: ['',[]],
      country: [sessionStorage.getItem('country'),[],[]],
      countryname1: ['0',[]],
      state: [sessionStorage.getItem('state'),[]],
      city: [sessionStorage.getItem('city'),[]],
      enteredcaptcha: ['',[]],
      generatedcaptcha: ['',[]],
      phonedialcode:['',[]],
      checkbox:[false,[]],
      appfrmtime:['',[]],
      apptotime:['',[]],
      appointmentdate:['',[]],
    })
  }
  }
  selectedclass: number = 1;
  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
    // this.navigateToHomeWithQueryParams();
    this.mainservice.generatecaptcha();
    this.captcha = localStorage.getItem('captcha')
     // ----country list--
     this.mainservice.getCountryList().subscribe(data=>{
       console.log(data);
       this.totalcountry=data;
     })
    }
  }
  //   setSeoMeta() {
  //     const seoData: ngxSeo.SeoSocialShareData = {
  //       title: 'Free Pharmacy Software for Efficient Pharmacy Management',
  //       description: 'Discover Medeil Standalone Pharmacy Software – the perfect solution for independent pharmacies. Manage inventory, billing, and prescriptions with ease.',
  //       image: 'https://www.medeil.com/assets/cloud-pos-software.jpg',
  //       url: 'https://www.medeil.com/medeil-cloud-pos',
  //       keywords: 'free pharmacy software, pharmacy management software, pharmacy billing software, inventory management for pharmacies'
  //     };

  //     this.seoService.setData(seoData);
  //   }
  //   setWebsiteSchema() {
  //     const schemaData = {
  //       "@context": "https://schema.org",
  //       "@type": "WebSite",
  //       "name": "Medeil Free Pharmacy Software",
  //       "url": "https://www.medeil.com",
  //       "description": "Discover Medeil Standalone Pharmacy Software – the perfect solution for independent pharmacies. Manage inventory, billing, and prescriptions with ease.",
  //       "image": "https://www.medeil.com/assets/img/logo/medeil_logo_1.png",
  //       "publisher": {
  //         "@type": "Organization",
  //         "name": "Medeil",
  //         "url": "https://www.medeil.com",
  //         "logo": {
  //           "@type": "ImageObject",
  //           "url": "https://www.medeil.com/assets/img/logo/medeil_logo_1.png"
  //         }
  //       },
  //     };

  //     this.jsonLdService.setData(schemaData);
  //   }
  // setSchemaData() {
  //   const schemaData = {
  //     "@context": "https://schema.org",
  //     "@type": "SoftwareApplication",
  //     "name": "Medeil Free Pharmacy Software",
  //     "headline": "Free Pharmacy Software for Efficient Pharmacy Management",
  //     "description": "Discover Medeil Standalone Pharmacy Software – the perfect solution for independent pharmacies. Manage inventory, billing, and prescriptions with ease.",
  //     "url": "https://www.medeil.com/medeil-pharmacy-software",
  //     "image": "https://www.medeil.com/assets/images/medeil.png",
  //     "operatingSystem": "Windows, macOS",
  //     "applicationCategory": "BusinessApplication",
  //     "offers": {
  //       "@type": "Offer",
  //       "price": "0",
  //       "priceCurrency": "USD",
  //       "availability": "https://schema.org/InStock"
  //     },
  //     "aggregateRating": {
  //       "@type": "AggregateRating",
  //       "ratingValue": "4.6",
  //       "ratingCount": "8864"
  //     },
  //     "publisher": {
  //       "@type": "Organization",
  //       "name": "Medeil",
  //       "url": "https://www.medeil.com"
  //     },
  //     "keywords": "free pharmacy software, pharmacy management software, pharmacy billing software, inventory management for pharmacies"
  //   };

  //   this.jsonLdService.setData(schemaData);
  // }
  // setFaqSchemaData() {
  //   const faqSchema = {
  //     "@context": "https://schema.org",
  //     "@type": "FAQPage",
  //     "mainEntity": [
  //       {
  //         "@type": "Question",
  //         "name": "What is MEDEIL?",
  //         "acceptedAnswer": {
  //           "@type": "Answer",
  //           "text": "MEDEIL is a comprehensive pharmacy management software developed by Vanuston Intelligence. It helps pharmacies manage inventory, prescriptions, and enhance patient care."
  //         }
  //       },
  //       {
  //         "@type": "Question",
  //         "name": "Is MEDEIL easy to use?",
  //         "acceptedAnswer": {
  //           "@type": "Answer",
  //           "text": "Yes, MEDEIL is designed with user-friendly interfaces and intuitive navigation, making it easy for pharmacy staff to use."
  //         }
  //       },
  //       {
  //         "@type": "Question",
  //         "name": "Does MEDEIL offer technical support and training?",
  //         "acceptedAnswer": {
  //           "@type": "Answer",
  //           "text": "Yes, MEDEIL provides technical support and training to help pharmacies implement the software successfully."
  //         }
  //       },
  //       {
  //         "@type": "Question",
  //         "name": "How can I get more information about MEDEIL?",
  //         "acceptedAnswer": {
  //           "@type": "Answer",
  //           "text": "For more details, visit the official website of Vanuston Intelligence at medeil.com."
  //         }
  //       }
  //     ]
  //   };

  //   this.addJsonLdToHead(faqSchema);
  // }


  // setSeoMeta() {
  //   const seoData: ngxSeo.SeoSocialShareData = {
  //     title: $localize`:@@SEO.TITLE_STANDALONE:Free Pharmacy Software for Efficient Pharmacy Management`,
  //     description: $localize`:@@SEO.DESCRIPTION_STANDALONE:Discover Medeil Standalone Pharmacy Software – the perfect solution for independent pharmacies. Manage inventory, billing, and prescriptions with ease.`,
  //     image: 'https://www.medeil.com/assets/cloud-pos-software.jpg',
  //     url: 'https://www.medeil.com/en/medeil-cloud-pos',
  //     keywords: $localize`:@@SEO.KEYWORDS_STANDALONE:free pharmacy software, pharmacy management software, pharmacy billing software, inventory management for pharmacies`
  //   };

  //   this.seoService.setData(seoData);
  // }
//   setSeoMeta() {
//  const supportedLanguages = ['en', 'fr', 'es', 'pt'];
//       let finalUrl = '';

//       if (isPlatformBrowser(this.platformId)) {
//         const origin = window.location.origin;
//         const path = window.location.pathname;
//         const parts = path.split('/');

//         let lang = 'en'; // Default
//         if (supportedLanguages.includes(parts[1])) {
//           lang = parts[1];
//         }

//         const fullPath = path.replace(/^\/[a-z]{2}/, '');
//         finalUrl = `${origin}/${lang}${fullPath}`;
//       }

//     const seoData = {
//       title: 'Free Pharmacy Software for Efficient Pharmacy Management',
//       description:`Discover Medeil Standalone Pharmacy Software – the perfect solution for independent pharmacies. Manage inventory, billing, and prescriptions with ease.`,
//       image: 'https://www.medeil.com/assets/cloud-pos-software.jpg',
//       url: finalUrl,
//       keywords: 'free pharmacy software, pharmacy management software, pharmacy billing software, inventory management for pharmacies'
//     };

//     this.title.setTitle(seoData.title);
//     const metaTags = [
//       { name: 'description', content: seoData.description },
//       { name: 'keywords', content: seoData.keywords },
//       { property: 'og:title', content: seoData.title },
//       { property: 'og:description', content: seoData.description },
//       { property: 'og:url', content: seoData.url },
//       { property: 'og:type', content: 'website' },
//       { property: 'og:image', content: seoData.image }
//     ];

//     metaTags.forEach(tag => this.meta.updateTag(tag));
//   }


setSeoMeta() {
  const supportedLanguages = ['en', 'fr', 'es', 'pt'];
  let finalUrl = '';

  if (isPlatformBrowser(this.platformId)) {
    const origin = window.location.origin;
    const path = window.location.pathname;
    const parts = path.split('/');

    let lang = 'en'; // Default
    if (supportedLanguages.includes(parts[1])) {
      lang = parts[1];
    }

    // const fullPath = path.replace(/^\/[a-z]{2}/, '');
    // finalUrl = `${origin}/${lang}${fullPath}`;
    const fullPath = path.replace(/^\/[a-z]{2}/, '').replace(/\/+$/, ''); // remove trailing slash
finalUrl = `${origin}/${lang}${fullPath ? '/' + fullPath : ''}`;

  }


    const seoData: ngxSeo.SeoSocialShareData = {
      title: $localize`:@@SEO.TITLE_STANDALONE:Free Pharmacy Software for Efficient Pharmacy Management`,
      description: $localize`:@@SEO.DESCRIPTION_STANDALONE:Discover Medeil Standalone Pharmacy Software – the perfect solution for independent pharmacies. Manage inventory, billing, and prescriptions with ease.`,
      image: 'https://www.medeil.com/assets/cloud-pos-software.jpg',
      url: 'https://www.medeil.com/en/medeil-cloud-pos',
      keywords: $localize`:@@SEO.KEYWORDS_STANDALONE:free pharmacy software, pharmacy management software, pharmacy billing software, inventory management for pharmacies, best standalone pharmacy software, pharmacy software for small business, standalone pharmacy billing software, free standalone pharmacy billing software, free pharmacy billing software, best phamracy software,`
    };

  this.title.setTitle(seoData.title);

  const metaTags = [
    { name: 'description', content: seoData.description },
    { name: 'keywords', content: seoData.keywords },
    { property: 'og:title', content: seoData.title },
    { property: 'og:description', content: seoData.description },
    { property: 'og:url', content: seoData.url },
    { property: 'og:type', content: 'website' },
    { property: 'og:image', content: seoData.image }
  ];

  metaTags.forEach(tag => this.meta.updateTag(tag));
}




  setWebsiteSchema() {
    const schemaData = {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": $localize`:@@SCHEMA.WEBSITE_NAME_STANDALONE:Medeil Free Pharmacy Software`,
      "url": "https://www.medeil.com",
      "description": $localize`:@@SCHEMA.WEBSITE_DESCRIPTION_STANDALONE:Discover Medeil Standalone Pharmacy Software – the perfect solution for independent pharmacies. Manage inventory, billing, and prescriptions with ease.`,
      "image": "https://www.medeil.com/assets/img/logo/medeil_logo_1.png",
      "publisher": {
        "@type": "Organization",
        "name": "Medeil",
        "url": "https://www.medeil.com",
        "logo": {
          "@type": "ImageObject",
          "url": "https://www.medeil.com/assets/img/logo/medeil_logo_1.png"
        }
      }
    };

    this.jsonLdService.setData(schemaData);
  }

  setSchemaData() {
    const schemaData = {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      "name": $localize`:@@SCHEMA.SOFTWARE_NAME_STANDALONE:Medeil Free Pharmacy Software`,
      "headline": $localize`:@@SCHEMA.HEADLINE_STANDALONE:Free Pharmacy Software for Efficient Pharmacy Management`,
      "description": $localize`:@@SCHEMA.DESCRIPTION_STANDALONE:Discover Medeil Standalone Pharmacy Software – the perfect solution for independent pharmacies. Manage inventory, billing, and prescriptions with ease.`,
      "url": "https://www.medeil.com/medeil-pharmacy-software",
      "image": "https://www.medeil.com/assets/images/medeil.png",
      "operatingSystem": "Windows, macOS",
      "applicationCategory": "BusinessApplication",
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "USD",
        "availability": "https://schema.org/InStock"
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.6",
        "ratingCount": "8864"
      },
      "publisher": {
        "@type": "Organization",
        "name": "Medeil",
        "url": "https://www.medeil.com"
      },
      "keywords": $localize`:@@SCHEMA.KEYWORDS_STANDALONE:free pharmacy software, pharmacy management software, pharmacy billing software, inventory management for pharmacies`
    };

    this.jsonLdService.setData(schemaData);
  }

  setFaqSchemaData() {
    const faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": $localize`:@@FAQ.QUESTION1_STANDALONE:What is MEDEIL?`,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": $localize`:@@FAQ.ANSWER1_STANDALONE:MEDEIL is a comprehensive pharmacy management software developed by Vanuston Intelligence. It helps pharmacies manage inventory, prescriptions, and enhance patient care.`
          }
        },
        {
          "@type": "Question",
          "name": $localize`:@@FAQ.QUESTION2_STANDALONE:Is MEDEIL easy to use?`,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": $localize`:@@FAQ.ANSWER2_STANDALONE:Yes, MEDEIL is designed with user-friendly interfaces and intuitive navigation, making it easy for pharmacy staff to use.`
          }
        },
        {
          "@type": "Question",
          "name": $localize`:@@FAQ.QUESTION3_STANDALONE:Does MEDEIL offer technical support and training?`,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": $localize`:@@FAQ.ANSWER3_STANDALONE:Yes, MEDEIL provides technical support and training to help pharmacies implement the software successfully.`
          }
        },
        {
          "@type": "Question",
          "name": $localize`:@@FAQ.QUESTION4_STANDALONE:How can I get more information about MEDEIL?`,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": $localize`:@@FAQ.ANSWER4_STANDALONE:For more details, visit the official website of Vanuston Intelligence at medeil.com.`
          }
        }
      ]
    };

    this.addJsonLdToHead(faqSchema);
  }



  addJsonLdToHead(schema: any) {
    const script = this.renderer.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schema);
    script.id = 'faq-schema';

    // Remove old schema if exists
    const oldScript = document.getElementById('faq-schema');
    if (oldScript) {
      oldScript.remove();
    }

    this.renderer.appendChild(document.head, script);
  }
  selectclass(index: number): void {
    this.selectedclass = index;
  }
  appointment(datasource:any){
    this.enquiryForm.get('sourceRef1').setValue(datasource);
    this.ngxsmartservice.open('enquirypos');
    // this.ngxsmartservice.open('appointmentform');
  }
  closeModal(): void {
    this.ngxsmartservice.close('enquirypos');
    this.ngxsmartservice.close('appointmentform');
    this.enquiryForm.reset();
    this.enquiryForm.get('countryname1').setValue('0');
    this.generatecaptcha();
  }
  countrychange(){

    this.mainservice.getMobileCode(this.enquiryForm.get('countryname1').value).subscribe((data)=>{
      //console.log(data);
      this.dialcode=data.Dailingcode;
      console.log(this.dialcode);
     // this.registerForm.get('phonedialcode').patchValue(this.dialcode[1]);
    })
  }
  checkCaptcha(){

    var usercaptcha = this.enquiryForm.get('enteredcaptcha').value

    if (this.captcha == usercaptcha) {
      this.ecaptcha = false

    } else {

      this.errorcaptcha = 'Enter correct Captcha'
      this.ecaptcha = true
    }
  }
  generatecaptcha(){
    this.mainservice.generatecaptcha()
    this.captcha = localStorage.getItem('captcha')
  }
  submitenquery(){
    let valid=this.validation();
    if(valid){
      this.ngxsmartservice.close('enquirypos');
      this.ngxsmartservice.open('appointmentform');
      this.picker.open();
      this.inputField.focus();
    }

  }

  validation(){
    let name=this.enquiryForm.get('leadname').value
    let organizationname=this.enquiryForm.get('organizationname').value
    let primaryemail=this.enquiryForm.get('primaryemail').value
    let primaryphone=this.enquiryForm.get('primaryphone').value
    let captcha=this.enquiryForm.get('enteredcaptcha').value
    let checkbox=this.enquiryForm.get('checkbox').value

    // var usercaptcha = this.registerForm.get('enteredcaptcha').value
    if(!name){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Enter Name',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }
    else if(!organizationname){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Enter Organization Name',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }
    else if(!primaryemail){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Enter Your Email',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }
    else if(!primaryphone){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Enter Your Mobile Number',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }
    else if(!captcha){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Enter Captcha',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }
    else if(captcha != this.captcha){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Enter Correct Captcha',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }
    else if(checkbox==false){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Select Accept & Terms condition',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }


    return true
  }
  slectdate(event: any){
    this.showElement=true;
    const selectedDate = event.value;
    const finalDate = this.datePipe.transform(selectedDate, 'yyyy-MM-dd');
    this.enquiryForm.get('appointmentdate').setValue(finalDate);
   this.currentTime = new Date();

   let map={
    "timezone":this.timezone,
    "orginaltimezone":this.currentTime
  }
  this.mainservice.gettimeSlots(map).subscribe(data=>{
    this.timeSlots = data[0].map((time:any)=> {
      const [hours, minutes] = time.split(':');
      const hours12 = ((parseInt(hours) + 11) % 12) + 1;
      const ampm = parseInt(hours) < 12 ? 'AM' : 'PM';
      return `${hours12}:${minutes} ${ampm}`;
    });
    this.showElement=false;
    console.log(this.timeSlots);
  })

    this.appointment_time=true;
  }
  selectTime(time: string): void {
    const currentTime = new Date();
    const formattedTime = this.datePipe.transform(currentTime, 'hh:mm:ss a');
    console.log(formattedTime);
    this.selectedTime = time;
    // this.enquiryForm.get('apptotime').setValue(time);
    this.enquiryForm.get('appfrmtime').setValue(time);

  }
  savelead(){
    this.showElementsave=true;



    // if (valid) {

      let phone = this.enquiryForm.get('primaryphone').value

      let mobileno=this.enquiryForm.get('phonedialcode').value+this.enquiryForm.get('primaryphone').value
      this.enquiryForm.get('primaryphone').setValue(mobileno)

       console.log('form',this.enquiryForm.value);

  this.mainservice.savelead(this.enquiryForm.value).subscribe((data: any) => {
    this.leads = data
    // console.log("this.leads",this.leads)
    if (data) {
      // this.enquiryForm.reset()
      this.showElementsave=false;
      // window.location.href= 'https://www.vanuston.com/thank-u-vanuston'
      this.enquiryForm.reset();

      // this.submitenquery();
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Data saved successfully',
        text: 'We will contact you shortly.',
        showConfirmButton: false,
        timer: 4000
      });
      this.ngxsmartservice.close('enquirypos');
      this.ngxsmartservice.close('appointmentform');
      this.enquiryForm.reset();
    }
     else{
      this.enquiryForm.get('primaryphone').setValue(phone);
      // this.showElement=false;
    }
    this.enquiryForm.get('countryname1').setValue('0');
    this.generatecaptcha();
  })

  }
  closepopup(){
    this.ngxsmartservice.close('myModal');
    this.enquiryForm.reset();

    this.enquiryForm.get('countryname1').setValue('0');
    this.generatecaptcha();
  }
  closepopup1(){
    this.ngxsmartservice.close('myModal1');
    this.enquiryForm.reset();

    this.enquiryForm.get('countryname1').setValue('0');
    this.generatecaptcha();
  }
  trynowbtn(data:any){
    // this.enquiryForm.reset();
    this.enquiryForm.get('sourceRef1').setValue(data);
    this.ngxsmartservice.open('myModal');

  }
  savesignup(){


    let valid=this.validation();

    if (valid) {
      this.showElement=true;
      let phone = this.enquiryForm.get('primaryphone').value

      let mobileno=this.enquiryForm.get('phonedialcode').value+this.enquiryForm.get('primaryphone').value
      this.enquiryForm.get('primaryphone').setValue(mobileno)

       console.log('form',this.enquiryForm.value);

  this.mainservice.savelead(this.enquiryForm.value).subscribe((data: any) => {
    this.leads = data
    // console.log("this.leads",this.leads)
    if (data) {
      // this.enquiryForm.reset()
      // window.location.href= 'https://www.vanuston.com/thank-u-vanuston'
      this.enquiryForm.reset();
      this.showElement=false;
      // this.submitenquery();
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Data saved successfully',
        text: 'We will contact you shortly.',
        showConfirmButton: false,
        timer: 4000
      });
      this.ngxsmartservice.close('myModal');
    }
     else{
      this.enquiryForm.get('primaryphone').setValue(phone);
      this.showElement=false;
    }
    this.enquiryForm.get('countryname1').setValue('0');
    this.generatecaptcha();
  })

    }
    else{
      this.showElement=false;
    }


  }
  broucher(data:any){
    this.enquiryForm.get('sourceRef1').setValue(data);
    this.ngxsmartservice.open('myModal1');
  }
  savebroucher() {
    let valid = this.validation();


    if (valid) {
      this.showElementsave = true;
      let phone = this.enquiryForm.get('primaryphone').value;
      let mobileno = this.enquiryForm.get('phonedialcode').value + this.enquiryForm.get('primaryphone').value;
      this.enquiryForm.get('primaryphone').setValue(mobileno);

      console.log('form', this.enquiryForm.value);

      this.mainservice.savelead(this.enquiryForm.value).subscribe(
        (data: any) => {

          this.leads = data;

          if (data) {
            this.enquiryForm.reset();
            this.showElementsave = false;
            Swal.fire({
              title: "Do you want to view the Brochure?",
              // showDenyButton: true,
              // showCancelButton: true,
              confirmButtonText: "yes",

            }).then((result) => {

              if (result.isConfirmed) {

            const url = 'https://medeilpos.blob.core.windows.net/websitedocuments/MEDEIL-PMSProductBrochure.pdf';
            window.open(url, '_blank');
              }
            });
            this.ngxsmartservice.close('myModal1');


          } else {
            this.enquiryForm.get('primaryphone').setValue(phone);
            this.showElement = false;
          }

          this.enquiryForm.get('countryname1').setValue('0');
          this.generatecaptcha();
        },
        (error: any) => {
          console.error('Error saving form', error);
          this.enquiryForm.get('primaryphone').setValue(phone);
          this.showElement = false;
        }
      );
    } else {
      this.showElement = false;
    }
  }
}
